import React, { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { AppContextProvider } from 'context';

import { DefaultTheme, ThemeProvider } from 'styled-components';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';

import { useOutletContext } from 'react-router-dom';

import { PageHandler } from 'pages';

import Modal from 'components/Modal';
import { RiskFlowControl } from 'types/RiskControl';
import GlobalStyle from '../global.styles';

const dsTheme = dsTokens as unknown;

export const RiskMotorFlow: FC = () => {
  const outletContext = useOutletContext<RiskFlowControl>();
  const fallbackRender = (): JSX.Element => null;

  return (
    <AppContextProvider>
      <ThemeProvider theme={dsTheme as DefaultTheme}>
        <ErrorBoundary fallbackRender={fallbackRender}>
          <GlobalStyle />
          {outletContext?.riskFlow?.data?.isHighRisk &&
            !outletContext?.riskFlow?.riskProcessed && (
              <Modal isOpen>
                <PageHandler />
              </Modal>
            )}
          <div className="portal-riskMotorFlow" />
        </ErrorBoundary>
      </ThemeProvider>
    </AppContextProvider>
  );
};

export default RiskMotorFlow;
